import WorkspacesIcon from "@mui/icons-material/Workspaces";
import useExcelUrl from "app/useExcelUrl";
import {
  DataGridV2 as DataGrid,
  DataGridBaseBaseProps,
  DataGridModalEditColumn,
  GridColumns,
  PageHeader,
} from "common";
import useAccess from "features/profile/useAccess";
import I18n from "i18n";
import { SeatingLayoutItem } from "./seatingLayoutApi";
import SeatingLayoutForm from "./SeatingLayoutForm";
import useSeatingLayoutList from "./useSeatingLayoutList";
export interface SeatingLayoutListProps extends Omit<
  DataGridBaseBaseProps,
  "id"
> {
  showHeader?: boolean;
}

export default function SeatingLayoutList({
  showHeader = true,
  ...props
}: SeatingLayoutListProps) {
  const { params, scope, editUrl, ...service } = useSeatingLayoutList();
  const { hasPermissions, canEditItem } = useAccess();
  const excelUrl = useExcelUrl("seating-layouts");
  let columns: GridColumns<SeatingLayoutItem> = [
    {
      field: "name",
      headerName: I18n.t("SeatingLayout.attributes.name"),
      renderCell: params => (
        <DataGridModalEditColumn
          href={`${editUrl}${params.row?.id}`}
          params={params}
        />
      ),
      flex: 1,
    },
  ];

  return (
    <>
      {showHeader && (
        <PageHeader
          avatar={<WorkspacesIcon />}
          title={I18n.t("SeatingLayout.title")}
        />
      )}
      <DataGrid
        {...service}
        columns={columns}
        id="seating-layouts"
        excelUrl={excelUrl}
        renderModalForm={props => <SeatingLayoutForm {...props} />}
        modalProps={{ maxWidth: "xl" }}
        {...props}
        //getHeaderName={field => I18n.t(`SeatingLayout.attributes.${field.replaceAll(".", "_")}`)}
        canCreate={hasPermissions("seating_layout.create")}
        canDelete={hasPermissions([
          "seating_layout.editany",
          "seating_layout.editown",
        ])}
        canEdit={hasPermissions([
          "seating_layout.editany",
          "seating_layout.editown",
        ])}
        canDeleteRow={params => canEditItem("seating_layout", params.row)}
        canEditRow={params => canEditItem("seating_layout", params.row)}
        canBatchActions={hasPermissions([
          "seating_layout.editany",
          "seating_layout.editown",
        ])}
        canHandleTrash={hasPermissions([
          "seating_layout.editany",
          "seating_layout.editown",
        ])}
      />
    </>
  );
}
